import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { AnchoredDropdown } from '@/components/common/admin/desktop/dropdown/AnchoredDropdown';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';
import { AnchorRect } from '@/hooks/common/useAnchoredPosition';
import { desktopDropdownStyles as styles } from '@/components/common/admin/desktop/dropdown/DesktopDropdownStyles';

interface DesktopChatOptionsProps {
  isOpen: boolean;
  anchor: AnchorRect | null;
  onClose: () => void;
  onShowDetails: () => void;
  onEdit: () => void;
  onArchive: () => void;
  onThreadOwner: () => void;
  isArchiving?: boolean;
}

export const DesktopChatOptions: React.FC<DesktopChatOptionsProps> = ({
  isOpen,
  anchor,
  onClose,
  onShowDetails,
  onEdit,
  onArchive,
  onThreadOwner,
  isArchiving = false,
}) => {
  return (
    <AnchoredDropdown isOpen={isOpen} anchor={anchor} width={260} maxHeight={360} onRequestClose={onClose}>
      <View>
        <TouchableOpacity
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onShowDetails();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.FOLDER width={18} height={18} color={ADMIN_COLORS.TEXT.PRIMARY} />
          </View>
          <Text style={styles.menuText}>Show Details</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onEdit();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.PENCIL width={18} height={18} color={ADMIN_COLORS.TEXT.PRIMARY} />
          </View>
          <Text style={styles.menuText}>Edit Conversation</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.menuItem}
          onPress={onArchive}
          disabled={isArchiving}
        >
          <View style={[styles.iconWrap, isArchiving ? { opacity: 0.5 } : null]}>
            <SVG_COMPONENTS.ARCHIVE width={18} height={18} color={ADMIN_COLORS.TEXT.PRIMARY} />
          </View>
          <Text style={styles.menuText}>Archive Conversation</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.menuItem}
          onPress={() => {
            onClose();
            onThreadOwner();
          }}
        >
          <View style={styles.iconWrap}>
            <SVG_COMPONENTS.ADMIN width={18} height={18} color={ADMIN_COLORS.TEXT.PRIMARY} />
          </View>
          <Text style={styles.menuText}>Thread Owner</Text>
        </TouchableOpacity>
      </View>
    </AnchoredDropdown>
  );
};
